import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { FrontendContextService, LogService, MibpLogger } from 'root/services';
import { BasicChartData } from 'root/components/chart/chart.types';
import { Subscription } from 'rxjs';
import { MibpSessionService } from 'root/services/mibp-session/mibp-session.service';

import { SystemMessageComponent } from 'root/components/system-message/system-message.component';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpChartPieComponent } from 'root/components/chart/mibp-chart-pie/mibp-chart-pie.component';
import { MibpNewPopoverComponent } from 'root/shared/components/popovers/new-popover/new-popover.component';
import { EcommerceRouterLinkDirective } from 'root/directives/ecommerce-router-link/ecommerce-router-link.directive';
import { equipmentsFnGetEquipmentFleetCount } from "root/mibp-openapi-gen/fn/equipments/equipments-fn-get-equipment-fleet-count";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  selector: 'mibp-dashboard-myfleet',
  templateUrl: './dashboard-tile-myfleet.component.html',
  styleUrls: ['./dashboard-tile-myfleet.component.scss', '../../modules/dashboard/pages/temporary-tiles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SystemMessageComponent, ResourceStringComponent, MibpChartPieComponent, MibpNewPopoverComponent, EcommerceRouterLinkDirective]
})
export class DashboardTileMyFleetComponent implements OnInit, OnDestroy {
  private mibpApiService = inject(MibpApiService);
  private sessionService = inject(MibpSessionService);
  private context = inject(FrontendContextService);
  fleetCount = 0;
  fleetActiveCount = 0;
  fleetStandbyCount = 0;
  isLoading = true;
  hasError = false;
  fleetChartData = null;
  deliverySequenceSubscription: Subscription;
  logger: LogService;
  private log: MibpLogger;

  constructor()
  { this.log = this.logger.withPrefix('dashboard-tile-myfleet.component'); }

  ngOnInit() {
    this.deliverySequenceSubscription = this.sessionService.activeDeliverySequence$.subscribe(() => this.update());
  }

  ngOnDestroy() {
    if (this.deliverySequenceSubscription) {
      this.deliverySequenceSubscription.unsubscribe();
    }
  }

  update() {
    this.hasError = false;
    this.isLoading = true;
    this.fleetChartData = null;
    this.fleetActiveCount = 0;
    this.fleetCount = 0;
    this.fleetStandbyCount = 0;
    this.mibpApiService.invoke(equipmentsFnGetEquipmentFleetCount, {body : {
      query: "",
      skip: 0,
      take: 0
    }  }).subscribe(result => {
      if (result) {
        this.fleetActiveCount = result.active;
        this.fleetStandbyCount = result.standby;
        this.fleetCount = result.count;
        this.fleetChartData = [
          {
            labelResourceString: 'MyFleet_Active',
            value: result.active
          },
          {
            labelResourceString: 'MyFleet_Standby',
            value: result.standby
          }
        ] as BasicChartData[];
      } else {
        this.fleetChartData = null;
      }
      this.isLoading = false;
    },
    (error) => {
      this.hasError = true;
      this.log.error('error Equipment Fleet Count',error);
    });
  }

}
